export const buildProductUsageOrEmpty = (data) => {
    if (!data) {
        return {
            productSku: null,
            daysLeftInTrial: null,
            numberOfExports: null,
            numberOfImports: null,
            stlImportsExports: null,
            hasCompletedAnyTraining: null,
            hasStartedAnyTraining: null,
            uUsageTimeL30D: 0,
            uUsageTimeTotal: 0,
            uUsageTimeL7D: 0,
            uOSProductUsageId: null,
        };
    }
    return {
        productSku: data.productSku || null,
        daysLeftInTrial: data.daysLeftInTrial || null,
        numberOfExports: data.numberOfExports || null,
        numberOfImports: data.numberOfImports || null,
        stlImportsExports: data.stlImportsExports || null,
        hasCompletedAnyTraining: data.hasCompletedAnyTraining || null,
        hasStartedAnyTraining: data.hasStartedAnyTraining || null,
        uUsageTimeL30D: data.uUsageTimeL30D || null,
        uUsageTimeTotal: data.uUsageTimeTotal || null,
        uUsageTimeL7D: data.uUsageTimeL7D || null,
        uOSProductUsageId: data.uOSProductUsageId || null,
    };
};
